/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { organizationsDelete } from "../../funcs/organizationsDelete.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request:
    operations
      .DeleteApiLeadScraperMicroserviceApiV1OrganizationIdRequest$inboundSchema,
};

export const tool$organizationsDelete: ToolDefinition<typeof args> = {
  name: "organizations_delete",
  description: `Delete an organization

Permanently deletes an organization and all associated resources`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await organizationsDelete(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
